{
  "EN": {
    "personalDetails": "Personal details",
    "academicDetails": "Academic details",
    "englishProficiencyDetails": "English proficiency details",
    "otherDetails": "Other details",
    "otherTestName": "Other Test Name",
    "back": "Back",
    "submit": "Submit"
  },
  "ID_IND": {
    "personalDetails": "Data pribadi",
    "academicDetails": "Data akademik",
    "englishProficiencyDetails": "Detail kemampuan bahasa Inggris",
    "otherDetails": "Data lainnya",
    "otherTestName": "Nama Tes Lain",
    "back": "Kembali",
    "submit": "Kirim"
  },
  "TH_THA": {
    "personalDetails": "ข้อมูลส่วนบุคคล",
    "academicDetails": "ข้อมูลการศึกษา",
    "englishProficiencyDetails": "รายละเอียดความสามารถภาษาอังกฤษ",
    "otherDetails": "ข้อมูลอื่น ๆ",
    "otherTestName": "ชื่อการสอบอื่น",
    "back": "ย้อนกลับ",
    "submit": "ส่ง"
  },
  "KR_KOR": {
    "personalDetails": "개인 정보",
    "academicDetails": "학업 정보",
    "englishProficiencyDetails": "영어 능력 세부 정보",
    "otherDetails": "기타 정보",
    "otherTestName": "기타 시험 이름",
    "back": "뒤로",
    "submit": "제출"
  },
  "TW_CHI": {
    "personalDetails": "個人資料",
    "academicDetails": "學歷資料",
    "englishProficiencyDetails": "英語能力詳情",
    "otherDetails": "其他資料",
    "otherTestName": "其他考試名稱",
    "back": "返回",
    "submit": "提交"
  },
  "HK_CHI": {
    "personalDetails": "個人資料",
    "academicDetails": "學歷資料",
    "englishProficiencyDetails": "英語能力詳情",
    "otherDetails": "其他資料",
    "otherTestName": "其他考試名稱",
    "back": "返回",
    "submit": "提交"
  },
  "HK_ZK": {
    "personalDetails": "个人信息",
    "academicDetails": "学业信息",
    "englishProficiencyDetails": "英语能力详情",
    "otherDetails": "其他信息",
    "otherTestName": "其他考试名称",
    "back": "返回",
    "submit": "提交"
  }
}
